//
//  SDKWorkspaceInvoice.ts
//  Supernova SDK
//
//  Created by Supernova.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceInvoice {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.number = model.number;
        this.amount_due = model.amount_due;
        this.date = new Date(model.date);
        this.hostedUrl = model.hostedUrl;
        if (model.card) {
            this.card = {
                last4: model.card.last4 || null,
                expiryMonth: model.card.expiryMonth || null,
                expiryYear: model.card.expiryYear || null,
                brand: model.card.brand || null,
            };
        }
        else {
            this.card = null;
        }
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    toRemote() {
        return {
            id: this.id,
            number: this.number,
            amount_due: this.amount_due,
            date: this.date.toISOString(),
            hostedUrl: this.hostedUrl,
            // @ts-expect-error TS(2322): Type '{ last4: string | null; expiryMonth: string ... Remove this comment to see the full error message
            card: this.card,
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new WorkspaceInvoice(model);
    }
}
